module.exports = __webpack_public_path__ + "media/机器人实操基地15.593ba7ab.mp4";